import { Component, OnInit } from '@angular/core';
import { CommonHelper } from 'src/app/helpers/common';
import { UserHelper } from 'src/app/helpers/user';
import { CalendarModel } from 'src/app/models/calendar.model';
import { GameModel } from 'src/app/models/game.model';
import { UserModel } from 'src/app/models/user.model';
import { TranslatePipe } from 'src/app/pipes/translate.pipe';
import { AuthService } from 'src/app/services/auth.service';
import { GameService } from 'src/app/services/game.service';
import Swal from 'sweetalert2';
declare var $: any;
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css'],
  providers: [TranslatePipe]
})
export class CalendarComponent implements OnInit {
  public calendars: CalendarModel[] = [];
  public selectedDate:Date = new Date();
  private user: UserModel = this.userHelper.getUser();
  private isFromUsa = false;
  private requesting = false;
  public browserName = "";
  public get language(): string {
    return CommonHelper.storeLanguage;
  }
  constructor(
    private translatePipe: TranslatePipe,
    private authService: AuthService,
    private gameService: GameService,
    private commonHelper: CommonHelper,
    private userHelper: UserHelper
  ) { }

  ngOnInit() {
    this.addEmpty();
    this.authService.geolocation().subscribe((resp) => {
      if(resp['response']['data'].name_en.toLowerCase().indexOf('united states') !== -1){
        this.isFromUsa = true;
      }
      this.getGames();
      this.initDatePicker();
    }, error => {
      this.getGames();
      this.initDatePicker();
    });
  }

  public get dateDay(): string {
    return this.selectedDate.getDate() < 10 ? '0' + this.selectedDate.getDate() : this.selectedDate.getDate().toString();
  }

  public get dateMonth(): string {
      return this.selectedDate.getMonth() + 1 < 10 ? '0' + (this.selectedDate.getMonth() + 1) : (this.selectedDate.getMonth() + 1).toString();
  }

  public get dateYear(): string {
      return this.selectedDate.getFullYear() < 10 ? '0' + this.selectedDate.getFullYear() : this.selectedDate.getFullYear().toString();
  }

  private addEmpty(qty = 7){
    const today = new Date(this.selectedDate);
    const calendars: CalendarModel[] = [];
    for(let i = 0; i < qty; i++){
      const calendar = new CalendarModel();
      calendar.secondDate = new Date(today);
      today.setDate(today.getDate() + 1);
      calendars.push(calendar);
    }
    this.calendars = calendars;
  }

  private getGames(){
    if(!this.requesting){
      this.requesting = true;
      this.gameService.getGamesByDate(this.selectedDate, false, 6).subscribe( (data: any) => {
        this.requesting = false;
        const calendars = data.response;
        const nCalednars: CalendarModel[] = [];
        for(const title in calendars){
          const games = calendars[title];
          const gamesM: GameModel[] = [];
          for(var g in games){  
            //if( games[g].dateStart < "2023-01-31 23:59:59"){
            const row = games[g];
            const game: GameModel = new GameModel();
            game.name = row.name;
            const name = game.name.replace(' ', '');
            const nameParts = name.split('@');
            game.mlbid = row.mlbid;
            game.awayTeam.name = row.awayName;
            if(typeof nameParts[0] !== 'undefined')
              game.awayTeam.abbr = nameParts[0].replace(' ', '');
            game.homeTeam.name = row.homeName;
            if(typeof nameParts[1] !== 'undefined')
              game.homeTeam.abbr = nameParts[1].replace(' ', '');
            game.channels = row.channels;
            game.dateStart = CommonHelper.getDate(row.dateStart);
            game.gamesTicket = row.gamesTicket;
            game.onDemand = row.ondemand;
            game.probableAwayPlayer.name = row.playerProbableAway;
            game.probableHomePlayer.name = row.playerProbableHome;
            game.streaming = row.streaming;
            game.status = row.status;
            game.streamingId = row.streamingId;
            game.venue.name = row.venue;
            gamesM.push(game);
            //}
          }
          const calendar: CalendarModel = new CalendarModel();
          calendar.title = title;
          if( !this.isFromUsa || ( this.isFromUsa && !calendar.isCaribbean ) ){
            calendar.games = gamesM;
          }
          nCalednars.push(calendar);
          
        }
        this.calendars = nCalednars;
      }, (error: any) => {
        this.requesting = false;
        this.addEmpty();
      });
    }
  }

  public addDays(days: number){
    if(!this.requesting){
      this.selectedDate.setDate(this.selectedDate.getDate() + days);
      this.getGames();
    }
  }

  public openCalendar(){
    if(!this.requesting){
      $('#date-calendar').datepicker("show");
    }
  }

  public openPlayer(game:GameModel){
    if (this.authService.isAuthenticate()) {
      if (this.user.hasOneValidMembership) {
            this.browserName = this.commonHelper.detectBrowserName();
            if(this.browserName == 'firefox'){
                Swal.fire({
                    allowOutsideClick: false,
                    type: 'warning',
                    text: this.translatePipe.transform('browserType.errorFirefox'),
                    confirmButtonText: 'OK'
                });
            }else {
                window.location.href = '/player/' + game.mlbid;
            }
      } else {
        window.location.href = '/home#section-price';
      }
    } else {
      $('#modal-login').click();
      $('#displayLoginForm').click();
      this.commonHelper.prevUrl = '/player/' + game.mlbid;
    }
  }


  private initDatePicker(){
    $(document).ready(() => {
        $('#date-calendar').datepicker({
          onSelect: (date) => {
            const dateParts = date.split('/');
            console.log(dateParts);
            const dateN = new Date();
            dateN.setFullYear(dateParts[2]);
            if(this.language == 'es'){
              dateN.setDate(dateParts[0]);
              dateN.setMonth(parseInt(dateParts[1]) - 1);
            } else {
              dateN.setDate(dateParts[1]);
              dateN.setMonth(parseInt(dateParts[0]) - 1);
            }
            this.selectedDate = dateN;
            this.getGames();
          }
        });
        if(this.language == 'es'){
          $.datepicker.regional['es'] = {
              closeText: 'Cerrar',
              currentText: 'Hoy',
              monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre',
                  'Octubre', 'Noviembre', 'Diciembre'
              ],
              monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov',
                  'Dic'],
              dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
              dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Juv', 'Vie', 'Sáb'],
              dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
              weekHeader: 'Sm',
              dateFormat: 'dd/mm/yy',
              yearSuffix: '',
          };
          $.datepicker.setDefaults($.datepicker.regional['es']);
        }
       
    });
  }

}
